import React from "react";
import Typography from "@mui/material/Typography";

export interface IMainPageTitleProps {
    header: string;
    text: string;
}

export const MainPageTitle = ({ header, text }: IMainPageTitleProps) => {
    return (
        <>
            <Typography
                variant="h1"
                gutterBottom
                sx={{ color: "success.main" }}
            >
                {header}
            </Typography>
            <Typography variant="h3" sx={{ color: "primary.dark" }}>
                {text}
            </Typography>
        </>
    );
};
